// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2EligibilityModel {
    static getAttributeTypeMap() {
        return EnrollmentV2EligibilityModel.attributeTypeMap;
    }
}
EnrollmentV2EligibilityModel.discriminator = undefined;
EnrollmentV2EligibilityModel.additionalProperties = false;
EnrollmentV2EligibilityModel.attributeTypeMap = [
    {
        "name": "status",
        "baseName": "status",
        "type": "EnrollmentStatus"
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentV2EligibilityModel.js.map